export default [
  {
    value: '6497BDA6-A864-EB11-80CF-005056AFAEEA',
    text: 'National Powersport Auctions',
    logo: 'logo-inverse.png',
  },
];
